import instance from "./interceptor";

async function get(url , param = {}){
    const response = await instance.get(url, { params: param });
    return response.data;
}

async function post(url , data = {}, config = {}){
    const response = await instance.post(url, data , config);
    return response.data;
}

async function del(url , data = {}){
    const response = await instance.delete(url, data );
    return response.data;
}


export default {
    get,
    post,
    del
}